export const paths = {
  community: '/experiences/community',
  techUnited: '/experiences/tech-united',
  eventRegister: '/experience/:id',
  noMemberEventRegister: '/no-member-experience/:id',
};
